export const ClientDocTypes = Object.freeze({
    OTHER: "other_kyc",
    miscellaneousDocumentUpload: 'miscellaneous_document_upload'
});